/* globals $ */
import envmap from '../../../../js/envmap.js'
import CustomSoundCloudPlayer from '../../../../js/player.js'
import svgcenter from '../../../../js/interface.js'

var textureDir = './images/textures/laluge'
var soundCloudUrl = '/quinzequinze/sets/gamineries/'
var playerSc = window.playerSc = new CustomSoundCloudPlayer(soundCloudUrl)
var param = []

$(document).ready(function () {
  $(document.body).fadeIn(3000, function () {
    $(document.body).removeClass('hidden')
    svgcenter()
  })
})

envmap.create(textureDir)

playerSc.scplayer.on('scplayer.changing_track', function (e, index) {
  this.scplayer.track_info(index).done(function (track) {
    console.log('la')
    if (typeof param !== 'undefined' && typeof envmap !== 'undefined') {
      envmap.setParams(param[index + 1])
    }
  })
  this.current_track = index
}.bind(playerSc))

playerSc.scplayer.on('scplayer.changing_track', function (e, index) {
  $('[track]').attr('active', false)
  $('[track]').attr('idle', true)
  $('[track]').attr('track_name', false)
  var i = index + 1
  $('[track=' + i + ']').attr('active', true)
  $('[track=' + i + ']').attr('idle', false)
  $('[track=' + i + ']').attr('track_name', true)

  if (this !== null) {
    this.changeTexture(index)
  }
}.bind(envmap))

param[1] = {
  lon: 0.15,
  phi: 90,
  x: 300,
  y: 100,
  z: 400
}

param[2] = {
  lon: 0.10,
  phi: 85,
  x: 180,
  y: 300,
  z: 100
}

param[3] = {
  lon: 0.2,
  phi: 40,
  x: 300,
  y: 500,
  z: 200
}

param[4] = {
  lon: 0.5,
  phi: 60,
  x: 300,
  y: 500,
  z: 200
}

param[5] = {
  lon: 0.05,
  phi: 85,
  x: 220,
  y: 300,
  z: 260
}

param[6] = {
  lon: 0.05,
  phi: 90,
  x: 300,
  y: 500,
  z: 200
}

param[7] = {
  lon: 0.9,
  phi: 120,
  x: 250,
  y: 560,
  z: 450
}
